<template>
  <label class="inline-flex items-center gap-1.5 cursor-pointer select-none">
    <input type="checkbox" class="accent-cyan-500 cursor-pointer"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)" />
    <span v-if="label">{{ label }}</span>
    <slot v-else />
  </label>
</template>

<script setup>
/**
 * BuilderCheckbox.vue
 *
 * The compact checkbox+label used inline in the Home Assistant builder
 * dialogs (e.g. a rule's "Default" toggle, "Enable interpolation") — see
 * BuilderSelect.vue's doc comment for why this exists separately from
 * the global form-checkbox component (that one lays out its label in a
 * fixed w-2/5 ratio meant for full-width property-panel rows, which
 * doesn't fit a tight inline row of several other controls).
 */
defineProps({
  modelValue: { type: Boolean, default: false },
  label:      { type: String, default: '' },
});
defineEmits(['update:modelValue']);
</script>
